import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/home";
import axios from "axios";

//Organizations
import OrganizationsRequestTranslation from "@/views/organizations/requestTranslation";
import OrganizationsIndex from "@/views/organizations/index";
import OrganizationsHelp from "@/views/organizations/help";
import OrganizationsAccredits from "@/views/organizations/accredView";
import OrganizationsButtons from "@/views/organizations/buttons";
import OrganizationsArchivio from "@/views/organizations/archivio";

//Users
import Profile from "@/views/users/profile";
import Register from "@/views/users/register";
import Login from "@/views/users/login";
import ResetPassword from "@/views/users/resetPassword";
import ChangePassword from "@/views/users/changePassword";

// Translators
import TranslatorIndex from "@/views/translators/index";
import TranslatorEdit from "@/views/translators/edit";
import TranslatorView from "@/views/translators/view";
import TranslatorTranslate from "@/views/translators/translate";
import TranslatorHelp from "@/views/translators/help";

// Pagine generali
import VoiceToSpeach from "@/views/voicetospeach";
import Compliance from "@/views/compliance";
import Privacy from "@/views/privacy";
import Audio from "@/views/audio";

Vue.use(VueRouter);
const siteName = " | Language Aid ";
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Home ",
    },
  },
  {
    path: "/login/:userType",
    name: "Login",
    component: Login,
    meta: {
      title: "Login ",
    },
  },
  {
    path: "/compliance",
    name: "Compliance",
    component: Compliance,
    meta: {
      title: "Compliance ",
    },
  },
  {
    path: "/users/profile/",
    name: "Profile",
    component: Profile,
    meta: {
      title: "Profilo ",
    },
  },
  {
    path: "/users/register/:userType",
    name: "Register",
    component: Register,
    meta: {
      title: "Register ",
    },
  },
  {
    path: "/voice_to_voice",
    name: "Voice to Voice",
    component: VoiceToSpeach,
    meta: {
      title: "Voice to Voice",
    },
  },
  {
    path: "/users/reset-password",
    name: "Reset Password",
    component: ResetPassword,
    meta: {
      title: "Reset Password",
    },
  },
  {
    path: "/users/change-password/:user_id",
    name: "Change Password",
    component: ChangePassword,
    meta: {
      title: "Change Password",
    },
  },
  {
    path: "/organization",
    name: "Organizations",
    component: OrganizationsRequestTranslation,
    meta: {
      title: "Richieste di Traduzione ",
    },
  },
  {
    //path: "/organizzations/register",
    //path: "/organization/accreditation",
    path: "/accreditation",
    name: "Organizations Accreditation",
    component: OrganizationsAccredits,
    meta: {
      title: "Richieste di Accreditamento ",
    },
  },
  {
    path: "/translator",
    name: "Translator",
    component: TranslatorTranslate,
    meta: {
      title: "Revisori ",
    },
  },
  {
    path: "/translators/help",
    name: "Help Translator",
    component: TranslatorHelp,
    meta: {
      title: "Help per Traduttori ",
    },
  },
  {
    path: "/organizations/help",
    name: "Help Organizations",
    component: OrganizationsHelp,
    meta: {
      title: "Help per Organizzazioni ",
    },
  },
  {
    path: "/audio",
    name: "Audio",
    component: Audio,
    meta: {
      title: "Registra un audio ",
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
    meta: {
      title: "Privacy Policy",
    },
  },
  {
    path: "/translators",
    name: "Translator Index",
    component: TranslatorIndex,
    meta: {
      title: "Ricerca Traduttori",
    },
  },
  {
    path: "/translators/edit/:user_id",
    name: "Translator Edit",
    component: TranslatorEdit,
    meta: {
      title: "Modifica Profilo Traduttore",
    },
  },
  {
    path: "/translators/view/:user_id",
    name: "Translator",
    component: TranslatorView,
    meta: {
      title: "Profilo del Traduttore",
    },
  },
  {
    path: "/organizations",
    name: "Organizations Index",
    component: OrganizationsIndex,
    meta: {
      title: "Organizzazioni Accreditate ",
    },
  },
  {
    path: "/organizations/index",
    name: "Organizations Index",
    component: OrganizationsButtons,
    meta: {
      title: "Organizzazioni Accreditate ",
    },
  },{
    path: "/organizations/archivio",
    name: "Organizations Archivio",
    component: OrganizationsArchivio,
    meta: {
      title: "Archivio ",
    },
  },
];

//Questo interceptor serve per mandarmi al login se la sessione è scaduta
axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    if (err.response.status === 401 || err.response.status === 403) {
      localStorage.removeItem("user");
      window.location.href = process.env.VUE_APP_LOGIN_URL;
    }
    throw err;
  }
);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

"/login",
  router.beforeEach((to, from, next) => {
    const publicPages = [
      "/users/register/translator",
      "/users/register/organization",
      "/",
      "/compliance",
      "/organizations/help",
      "/translators/help",
      "/login/translator",
      "/login/organization",
      "/users/reset-password",
      "/privacy",
      "/organizations",
      "/accreditation",
    ];
    let authRequired = !publicPages.includes(to.path);
    //Controllo specifico per il cambio password perchè contiene parametri
    if (to.path.startsWith("/users/change-password")) {
      authRequired = false;
    }
    const loggedIn = localStorage.getItem("user");
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find((r) => r.meta && r.meta.title);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title + siteName + (process.env.VUE_APP_GIT_TAG?process.env.VUE_APP_GIT_TAG:'');

    // trying to access a restricted page + not logged in
    // redirect to login page
    if (authRequired && !loggedIn) {
      next("/login/translator");
    } else {
      next();
    }
  });
export default router;
